import React from 'react';
import './Class.css';
import class8 from '../../Images/Class-8.png';
import {Helmet} from "react-helmet";
const Class8 = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Ashtveer - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>
    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={class8}
        loading="lazy"
        alt="Lakshya NEET 3.0"
        className="lakshya-image"
      />
      <div className="course-details">
  <p className="pricing">💳 Monthly Fees: ₹ 1299/-</p>
  <p className="pricing">💼 Fees Billed Till Exams: ₹ 6499/-</p>
  <a href="https://rzp.io/rzp/Ashtveer" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Asht<span className='highlight'>veer</span>(Class-<span className='highlight'>8</span>)</h2>
        
      </div>
    </div>

    {/* Batch Details Section */}
    <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Small Batches for Big Impact!</strong>  
    <ul>
      <li>👨‍🎓 Only 10 students per batch for focused and effective learning.</li>
    </ul>
  </li>
  <li><strong>2️⃣Subjects We Master Together</strong>  
    <ul>
      🧮 Mathematics
      🔬 Science
      📖 English
      🌍 Social Science (SST)
      ✍️ Hindi
    </ul>
  </li>
  <li><strong>3️⃣Daily Learning That Fits Your Schedule</strong>  
    <ul>
      <li>✨ Two engaging 1-hour classes daily with expert mentors.</li>
    </ul>
  </li>
  <li><strong>4️⃣24/7 Doubt-Solving at Your Fingertips!</strong>  
    <ul>
      <li>🔥 Stuck on a problem? Get instant help anytime, anywhere!</li>
    </ul>
  </li>
  <li><strong>5️⃣Interactive & Engaging Live Classes</strong>  
    <ul>
      <li>🎥Learn directly from seasoned tutors through real-time discussions.</li>
    </ul>
  </li>
  <li><strong>6️⃣Comprehensive Learning Resources</strong>  
    <ul>
      <li>📝 Stay ahead with class notes, practice sheets, and recorded sessions.</li>
    </ul>
  </li>
  <li><strong>7️⃣Live Quizzes, Badges & Rewards</strong>  
    <ul>
      <li>🏅 Compete in exciting quizzes, earn badges, and celebrate your victories!</li>
    </ul>
  </li>
  <li><strong>8️⃣Weekly PTMs & Progress Reports</strong>  
    <ul>
      <li>📊 Stay updated on performance with detailed reports and feedback sessions.</li>
    </ul>
  </li>
  <li><strong>9️⃣Weekly Tests for Continuous Improvement</strong>  
    <ul>
      <li>✍️Regular assessments to ensure you're always ahead of the curve.</li>
    </ul>
  </li>
  <li><strong>📩 Have More Questions?</strong>  
    <ul>
      <li>Reach us anytime at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>"Ashtveer"</span> Now & Power Up Your Class 8 Journey with Confidence! 🚀🌟</strong></li>
</ul>


    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
      <div className="faq-grid">
        <div className="faq-item">
        🎯
          <div>
            <h3>Who Should Join This Batch?</h3>
            <p>
            🎓 Ideal for Class 8 students who want to improve their subject understanding and prepare for upcoming exams.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Where Will the Classes Be Held?</h3>
            <p>💻 Classes are hosted on Zoom, and the links will be shared in your WhatsApp group.</p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>How Can I Get Help If I Have Doubts?</h3>
            <p>💬 Our 24/7 doubt-solving support is available for you to clear any doubts at your convenience.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>What If I Miss a Class?</h3>
            <p>
            📼 No problem! All classes are recorded and can be reviewed at any time.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Are Tests and Quizzes Mandatory?</h3>
            <p>
            ✅ Yes! Weekly tests and live quizzes are essential for continuous assessment and improvement.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Can I Get a Refund After Batch Purchase?</h3>
            <p>
            💡 Unfortunately, refunds are not allowed after purchasing a batch. We ensure the best resources and infrastructure are in place to benefit our students.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Class8;
